import EmptyState from '@cld/empty-state';
import { useMessage } from '../../i18n';
import { Page } from '../../components/Page.js';
import { PageTitle } from '../../components/PageTitle.js';

export const NotFoundPage = () => {
  const formatMessage = useMessage();

  return (
    <Page data-test="no-found-page">
      <PageTitle title={formatMessage('appName')} subtitle={formatMessage('notFound')} />
      <EmptyState
        imageHeight={100}
        imageSrc="https://cloudinary-res.cloudinary.com/image/upload/v1538583988/cloudinary_logo_for_white_bg.svg"
        imageWidth={200}
        title={formatMessage('pageNotFoundTitle')}
        subtitle={formatMessage('pageNotFoundMessage')}
      />
    </Page>
  );
};
